import { useIsMobile } from '@newfront-insurance/admin-ui';
import { cn } from '@newfront-insurance/core-ui/v2';
import { Settings } from 'lucide-react';

import { useChatOverlayContext } from '../contexts/chat-overlay-context';

/**
 * Composable notifications settings button component for navigator-nova chat sidebar.
 * Toggles settings panel in the main chat content area when clicked.
 * Styled to match sidebar menu items with cog icon and "Settings" text.
 *
 * This is similar to OutlookSettingsButton but only includes notifications,
 * not Outlook-specific settings.
 */
export function NotificationsSettingsButton() {
  const { isSettingsOpen, setIsSettingsOpen, setIsSidebarOpen } = useChatOverlayContext();
  const { isMobile } = useIsMobile();

  return (
    <button
      type="button"
      onClick={() => {
        setIsSettingsOpen(!isSettingsOpen);

        if (isMobile) {
          setIsSidebarOpen(false);
        }
      }}
      className={cn(
        'text-muted-foreground flex w-full items-center gap-2 px-2 py-1.5 text-start',
        'hover:bg-steel-100 dark:hover:bg-steel-400 rounded-xs',
      )}
    >
      <div className="flex size-6 shrink-0 items-center justify-center">
        <Settings className="h-4 w-4" />
      </div>
      <span>Settings</span>
    </button>
  );
}
